import IconDrakeCloud from './IconDrakeCloud';

export default IconDrakeCloud;